import { baseMarkPattern } from './__base'
export const strike = function strike (text) {
  return baseMarkPattern(text, '{-}')
}
